import React, { useEffect, useState } from "react";
import UserSideNav from "../../components/user/UserSideNav";
import UserHeader from "../../components/user/UserHeader";
import SmartDataTable from "../../components/shared/SmartDataTable";
import NumberBalls from "../../components/shared/NumberBalls";
import { Trophy, Loader2 } from "lucide-react";
import { resultsApi } from "../../services/api";

function fmtDate(d) {
  return d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "-";
}

export default function Results() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    resultsApi.getAll({ limit: 1000, page: 1 })
      .then((res) => setResults(res.data.data || []))
      .catch(() => setError("Failed to load results."))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { name: "Pool", selector: (row) => row.pool?.poolId || "", sortable: true, cell: (row) => <strong className="table-primary">{row.pool?.poolId || "-"}</strong> },
    { name: "Name", selector: (row) => row.pool?.name || "", sortable: true, cell: (row) => row.pool?.name || "-", grow: 1.25 },
    { name: "Draw Date", selector: (row) => row.drawDate || "", sortable: true, cell: (row) => fmtDate(row.drawDate) },
    { name: "Winning Numbers", cell: (row) => <NumberBalls numbers={row.winningWhiteBalls} power={row.winningPowerball} />, grow: 1.7 },
    { name: "Checker", selector: (row) => row.checkerRun ? "checked" : "pending", sortable: true, cell: (row) => <span className={`table-status ${row.checkerRun ? "live" : "warn"}`}>{row.checkerRun ? "Checked" : "Pending"}</span> },
  ];

  return (
    <div className="user-shell">
      <UserSideNav />
      <div className="user-app">
        <UserHeader />
        <main className="user-main">
          <div className="welcome-block">
            <div>
              <div className="page-kicker">Results</div>
              <h1>Draw Results</h1>
              <p>Official Powerball winning numbers entered by admin after each draw.</p>
            </div>
          </div>

          {error && <div className="auth-error">{error}</div>}

          {loading ? (
            <div className="page-loading"><Loader2 size={28} className="spin" /><span>Loading results...</span></div>
          ) : results.length === 0 ? (
            <div className="empty-state"><Trophy size={36} /><p>No draw results posted yet.</p></div>
          ) : (
            <section className="section-block">
              <div className="section-heading">
                <h2><Trophy size={20} /> Past Draws</h2>
                <span style={{ color: "var(--muted)", fontSize: 13 }}>{results.length} draws</span>
              </div>
              <SmartDataTable
                columns={columns}
                data={results}
                loading={false}
                searchFields={["pool.poolId", "pool.name", "drawDate", (row) => row.checkerRun ? "checked" : "pending"]}
                searchPlaceholder="Search draws by pool, date, checker status..."
                emptyMessage="No draw results posted yet."
                paginationPerPage={25}
              />
            </section>
          )}
        </main>
      </div>
    </div>
  );
}
